// Wire-format normaliser for a feature's remaining allowance.
//
// The backend expresses an UNLIMITED allowance as the literal string "inf"
// (subscription/permissions.py: `if limit == "inf": remaining_limit = "inf"`).
// Passed through raw, every downstream numeric comparison silently becomes NaN
// — `6 <= "inf"` is false — which is worse than a low balance: it reads as
// "you have none" for exactly the tiers that paid for unlimited. Normalise once
// here so no consumer ever has to know the wire format.
//
// Deliberately dependency-free so it can be unit-tested without dragging the
// component tree (and its CSS imports) into the test runner.
export const UNLIMITED = Infinity;

export const normalizeRemainingLimit = (raw) => {
  if (raw === "inf" || raw === Infinity) return UNLIMITED;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
};
